import {createReducer} from '../../utilities';
import {
  FAIL_GET_CHAMPIONSHIPS,
  REQUEST_GET_CHAMPIONSHIPS,
  SUCCESS_GET_CHAMPIONSHIPS,
} from '../../../actions/entities/championships';

const initialState = {
  data: null,
  error: false,
  isFetching: false,
};

function requestFetch(state) {
  return {
    ...state,
    isFetching: true,
  };
}

function successFetch(state, action) {
  const {response} = action;
  return {
    ...state,
    data: response.championships,
    isFetching: false,
  };
}

function failFetch(state, action) {
  const {error} = action;
  return {
    ...state,
    isFetching: false,
    error,
  };
}

export default createReducer(initialState, {
  [REQUEST_GET_CHAMPIONSHIPS]: requestFetch,
  [SUCCESS_GET_CHAMPIONSHIPS]: successFetch,
  [FAIL_GET_CHAMPIONSHIPS]: failFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/championships/list.js